export const environments = {
  JUKE_API_ENV: ['TEST', 'ACC', 'PREVIEW', 'PROD'],
  UNIVERSAL_API_ENV: ['TEST', 'ACC', 'PREVIEW', 'RELEASE', 'PROD'],
};

export const apiSelector = {
  JUKE_API: 'JukeApi',
  UNIVERSAL_API: 'UniversalApi',
};
